import type { FeedbackTranslations } from "@jti/fe-common/config";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

export type ContentFeedbackAction = {
  label: string;
  color?: "primary" | "secondary";
  href?: string;
  onClick?: () => void;
};

type GetContentFeedbackActionsParams = {
  isUserLoggedIn: boolean;
  feedbackTranslations: FeedbackTranslations;
  loginHref: string;
  authRegisterPageUrl: string;
  submitFeedback: (isHelpful: boolean) => Promise<void>;
  referenceType: string;
};

export const getContentFeedbackActions = ({
  isUserLoggedIn,
  feedbackTranslations,
  loginHref,
  authRegisterPageUrl,
  submitFeedback,
  referenceType,
}: GetContentFeedbackActionsParams): ContentFeedbackAction[] => {
  const handleClick = (isHelpful: boolean) => {
    dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
      cta_name: (isHelpful ? feedbackTranslations.helpful : feedbackTranslations.notHelpful) ?? "",
      cta_location: referenceType,
    });

    submitFeedback(isHelpful);
  };

  if (isUserLoggedIn) {
    return [
      {
        label: feedbackTranslations.helpful ?? "",
        onClick: () => handleClick(true),
      },
      {
        label: feedbackTranslations.notHelpful ?? "",
        onClick: () => handleClick(false),
      },
    ];
  }

  return [
    {
      label: feedbackTranslations.loginLabel ?? "",
      href: loginHref,
    },
    { label: feedbackTranslations.signUpLabel ?? "", color: "primary", href: authRegisterPageUrl },
  ];
};
